import { logger } from '@accedo/logger';
import tenApiService from '##/services/tenApi';
import { StandardCarouselItem } from '##/components/StandardCarousel/types';
import { isLoggedIn } from '##/services/authentication/Authentication';
import { config } from '##/services/store/store';
import { ContinueWatchingResponse } from '##/services/tenApi/playback/types';

export const getContinueWatchingData = async (): Promise<ContinueWatchingResponse | null> => {
  let continueWatchingRail: ContinueWatchingResponse | null = null;
  try {
    continueWatchingRail = await tenApiService.playback.getContinueWatchingData();
  } catch (err) {
    // silently fail and still load the app without the watch history rail
    logger.error(err);
    return null;
  }
  if (!continueWatchingRail?.items?.length) return null;
  return continueWatchingRail;
};

export const setWatchHistoryData = async (): Promise<void> => {
  try {
    const watchHistoryData = await tenApiService.playback.getPastProgressData();
    const localWatchHistoryData = watchHistoryData?.map((item) => ({
      progressMs: item.progress || 0,
      id: item.videoCode,
    }));
    config.$set({ watchHistory: localWatchHistoryData });
  } catch (err) {
    // silently fail and still load the app without progress data
    logger.error(err);
  }
};

export const addProgressToEpisodes = (
  episodes: StandardCarouselItem[],
): StandardCarouselItem[] => {
  if (!isLoggedIn()) return episodes;

  const { watchHistory: watchHistoryItems } = config.$get();
  return episodes.map((episode) => {
    const itemInHistory = watchHistoryItems?.find(
      (historyItem) => historyItem.id === episode.id,
    );
    return itemInHistory
      ? { ...episode, progress: itemInHistory.progressMs }
      : episode;
  });
};
